// WhatsApp Configuration
export const whatsappConfig = {
  phoneNumber: "27665288667", // Replace with your actual WhatsApp number (with country code, no + or spaces)
  message: "Ask Visio Anything",
  
  // Optional: Customize button appearance
  buttonStyle: {
    showTooltip: true,
    position: 'bottom-right', // 'bottom-right', 'bottom-left', 'top-right', 'top-left'
    animation: true
  }
};
